import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import useLocalization from "../../hooks/useLocalization";

const Dialog_YesNo = ({ open, onClose, title, message, onYes, onNo }) => {
  const { getLabel } = useLocalization();

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ whiteSpace: "pre-wrap" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onYes}>{getLabel("yes")}</Button>
        <Button onClick={onNo}>{getLabel("no")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default Dialog_YesNo;
